import React, { ReactElement } from 'react';
import { IBillingIconProps } from './types';
import { SCSvgPath, SCSvgRoot, SCSvgWrapper } from './styles';

const BillingIcon = ({ iconState, disabled }: IBillingIconProps): ReactElement => {
    return (
        <SCSvgWrapper
            data-testid={'billing_icon'}
            aria-disabled={disabled ? 'true' : 'false'}
            role="img"
            aria-label="Billing icon"
        >
            <SCSvgRoot
                aria-labelledby="Billing icon"
                role="group"
                width="100%"
                height="100%"
                viewBox="0 0 25 25"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlSpace="preserve"
            >
                <SCSvgPath
                    animate={iconState}
                    data-testid={iconState ? 'BillingIconActive' : 'BillingIconInactive'}
                    disabled={disabled}
                    d="M0 6.25C0 4.52411 1.39911 3.125 3.125 3.125H21.875C23.6009 3.125 25 4.52411 25 6.25V18.75C25 20.4759 23.6009 21.875 21.875 21.875H3.125C1.39911 21.875 0 20.4759 0 18.75V6.25ZM3.90625 7.8125C3.47478 7.8125 3.125 8.16228 3.125 8.59375V10.1562C3.125 10.5877 3.47478 10.9375 3.90625 10.9375H7.03125C7.46272 10.9375 7.8125 10.5877 7.8125 10.1562V8.59375C7.8125 8.16228 7.46272 7.8125 7.03125 7.8125H3.90625ZM3.90625 12.5C3.47478 12.5 3.125 12.8498 3.125 13.2812C3.125 13.7127 3.47478 14.0625 3.90625 14.0625H11.7188C12.1502 14.0625 12.5 13.7127 12.5 13.2812C12.5 12.8498 12.1502 12.5 11.7188 12.5H3.90625ZM3.90625 15.625C3.47478 15.625 3.125 15.9748 3.125 16.4062C3.125 16.8377 3.47478 17.1875 3.90625 17.1875H5.46875C5.90022 17.1875 6.25 16.8377 6.25 16.4062C6.25 15.9748 5.90022 15.625 5.46875 15.625H3.90625ZM8.59375 15.625C8.16228 15.625 7.8125 15.9748 7.8125 16.4062C7.8125 16.8377 8.16228 17.1875 8.59375 17.1875H10.1562C10.5877 17.1875 10.9375 16.8377 10.9375 16.4062C10.9375 15.9748 10.5877 15.625 10.1562 15.625H8.59375ZM13.2812 15.625C12.8498 15.625 12.5 15.9748 12.5 16.4062C12.5 16.8377 12.8498 17.1875 13.2812 17.1875H14.8438C15.2752 17.1875 15.625 16.8377 15.625 16.4062C15.625 15.9748 15.2752 15.625 14.8438 15.625H13.2812ZM17.9688 15.625C17.5373 15.625 17.1875 15.9748 17.1875 16.4062C17.1875 16.8377 17.5373 17.1875 17.9688 17.1875H19.5312C19.9627 17.1875 20.3125 16.8377 20.3125 16.4062C20.3125 15.9748 19.9627 15.625 19.5312 15.625H17.9688Z"
                />
            </SCSvgRoot>
        </SCSvgWrapper>
    );
};

export { BillingIcon };
